<div class="graph-container">
  <div class="graph-left">
    <div class="graph-toolbar">
      <mat-slide-toggle
        [checked]="checked()"
        (change)="toggleChange($event)"
        color="primary"
        >Disable Zoom</mat-slide-toggle
      >
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="zoom_in"
        (buttonClicked)="zoomIn()"
        ariaLabel="Zoom in"
      ></app-mat-icon-button>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="zoom_out"
        (buttonClicked)="zoomOut()"
        ariaLabel="Zoom out"
      ></app-mat-icon-button>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="crop_free"
        (buttonClicked)="setDragMode('zoom')"
        ariaLabel="Box zoom"
        [buttonStyle]="dragMode() === 'zoom' ? 'selected' : 'grey'"
      ></app-mat-icon-button>
      <app-mat-icon-button
        iconName="pan_tool"
        (buttonClicked)="setDragMode('pan')"
        ariaLabel="Pan"
        [buttonStyle]="dragMode() === 'pan' ? 'selected' : 'grey'"
      ></app-mat-icon-button>
      <span class="toolbar-divider"></span>
      <app-mat-icon-button
        iconName="scatter_plot"
        (buttonClicked)="setGraphMode('markers')"
        ariaLabel="Scatter plot"
        [buttonStyle]="graphMode() === 'markers' ? 'selected' : 'grey'"
      ></app-mat-icon-button>
      <app-mat-icon-button
        iconName="show_chart"
        (buttonClicked)="setGraphMode('lines+markers')"
        ariaLabel="Line plot"
        [buttonStyle]="graphMode() === 'lines+markers' ? 'selected' : 'grey'"
      ></app-mat-icon-button>
      <span class="toolbar-divider"></span>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="download"
        (buttonClicked)="downloadImage()"
        ariaLabel="Download as PNG"
      ></app-mat-icon-button>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="refresh"
        (buttonClicked)="resetZoom()"
        ariaLabel="Auto scale"
      ></app-mat-icon-button>
    </div>
    @if (errorMessage) {
      <div class="error--container">
        <p class="error">{{ errorMessage }}</p>
      </div>
    }
    <div #plotlyDiv [id]="graphId()"></div>

    <div class="legend--container">
      <div class="custom-legend">
        @for (
          device of legendData();
          track device.deviceId;
          let deviceIndex = $index
        ) {
          <div class="legend-device">
            <div class="legend-flasks">
              <div
                class="legend-device-name"
                (click)="toggleTrace(device.deviceName)"
              >
                {{ device.deviceName }}
              </div>
              @for (
                flask of device.flasks;
                track flask.name;
                let flaskIndex = $index
              ) {
                <div
                  class="legend-item"
                  [class.hidden]="!flask.visible"
                  (click)="toggleLegendItem(deviceIndex, flaskIndex)"
                >
                  <span
                    class="legend-color"
                    [style.background-color]="flask.colour"
                  ></span>
                  <span class="legend-label">{{ flask.name }}</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if (fluorescenceChannels().length > 1) {
        <div class="shape-legend">
          <div class="legend-device-name">Channels</div>
          @for (
            channel of fluorescenceChannels();
            track channel.memorySlot;
            let i = $index
          ) {
            <div class="shape-item">
              <span class="shape-icon" [attr.data-shape]="getChannelSymbol(i)">
                @switch (getChannelSymbol(i)) {
                  @case ("circle") {
                    <svg width="12" height="12" viewBox="0 0 12 12">
                      <circle cx="6" cy="6" r="5" fill="currentColor" />
                    </svg>
                  }
                  @case ("square") {
                    <svg width="12" height="12" viewBox="0 0 12 12">
                      <rect
                        x="1"
                        y="1"
                        width="10"
                        height="10"
                        fill="currentColor"
                      />
                    </svg>
                  }
                  @case ("triangle-up") {
                    <svg width="12" height="12" viewBox="0 0 12 12">
                      <polygon points="6,1 11,11 1,11" fill="currentColor" />
                    </svg>
                  }
                  @case ("diamond") {
                    <svg width="12" height="12" viewBox="0 0 12 12">
                      <polygon points="6,1 11,6 6,11 1,6" fill="currentColor" />
                    </svg>
                  }
                }
              </span>
              <span class="shape-label">{{ channel.channelName }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div class="graph-right">
    <div class="subtitle2">Advanced Settings</div>
    <div class="advanced--container">
      <app-underlined-form-field
        [field]="yMinRangeField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="yMaxRangeField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="xMinRangeField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="xMaxRangeField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="heightField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="widthField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-dropdown-form-field
        [parentForm]="advancedSettingsForm()"
        [field]="ratioField()"
      ></app-underlined-dropdown-form-field>
      <app-button
        buttonStyle="standard"
        label="Update"
        buttonId="range"
        (buttonClicked)="resizeGraph()"
        [isDisabled]="
          advancedSettingsForm().invalid || advancedSettingsForm().pristine
        "
      >
      </app-button>
    </div>
  </div>
</div>
@if (displayChannelFilter()) {
  <app-slide-toggle-group
    [field]="channelFilterField()"
    [parentForm]="fluorescenceChannelForm()"
    [allowMultipleSelection]="true"
  ></app-slide-toggle-group>
}
